export default function NormalSelectbox({
  title,
  options,
  selected,
  onChange,
}) {
  return (
    <div className="w-full space-y-1">
      <div className="font-[poppins] text-xs text-[#424242] font-normal leading-[20px] tracking-[0%]">
        {title}
      </div>
      <div className="relative">
        <select
          value={selected}
          onChange={(e) => onChange(e.target.value)}
          className="block w-full p-2 pr-8 border border-[#C2C2C2] rounded-[10px] font-[poppins] bg-[#FDFDFD] text-sm text-gray-700 focus:outline-none focus:ring-[#414651] focus:border-[#414651] appearance-none cursor-pointer"
        >
          <option value="" disabled></option>
          {options.map((item, idx) => (
            <option key={idx} value={item.key}>
              {item.value}
            </option>
          ))}
        </select>
        {/* Custom arrow */}
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <svg
            className="w-4 h-4 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
